<template>
    <div >
        <div style=" display:flex; width:100%;min-width:1400px;background:#fff;line-height:35px;border-bottom:2px solid #389;padding-top:3px">
            
            <div style="width:550px; "> 
                <div style="font-size:12px;display:flex;margin-left:5px">
                    <div style="width:90px;color:red" >树状BOM产品 </div>     
                    <el-input  size="medium" v-model="v_matno1" @focus="inputBtn('MATNO')"  placeholder="请选择BOM产品" style="width:140px;border:1px solid #389;height:35px"></el-input>
                    <el-input size="medium"  v-model="v_matnm1" disabled   style="width:320px"></el-input> 
                </div>
                <div style="font-size:12px;display:flex;margin-top:5px;margin-left:5px">
                    <div style="width:90px" > 规格描述</div>    
                    <el-input size="medium" type="textarea" rows="1" resize="none" v-model="v_specnm1" disabled  style="width:460px"></el-input> 
                </div>
            </div>

            <div style="width:550px;margin-left:20px;border-left:2px solid #ccc"> 
                <div style="font-size:12px;display:flex;margin-left:5px">
                    <div style="width:90px;color:black" >对比BOM产品 </div>     
                    <el-input  size="medium" v-model="v_matno2" @focus="inputBtn('MATNO2')" clearable  placeholder="请选择BOM产品" style="width:140px;border:1px solid #389; height:35px"></el-input>
                    <el-input size="medium"  v-model="v_matnm2" disabled   style="width:320px"></el-input> 
                </div>
                <div style="font-size:12px;display:flex;margin-top:5px;margin-left:5px">
                    <div style="width:90px;color:black" > 规格描述</div>    
                    <el-input size="medium" type="textarea" rows="1" resize="none" v-model="v_specnm2" disabled  style="width:460px"></el-input> 
                </div>
            </div> 
            <el-button type="primary" icon="iconfont icon-gaojichazhao2" @click="getBomList" style="margin-left:10px;font-size:14px;margin-bottom:3px ">查询 </el-button>
            <el-button type="success" icon="iconfont icon-daochu" @click="exportBomCompareExcel" :disabled="!tabData.length && !noData.length && !noData2.length" style="margin-left:15px;font-size:14px;margin-bottom:3px ">导出表格</el-button>  
                <!-- <div style="width:360px;height:35px; color:red;font-size:13px;font-weight:600;text-align:left;padding-left:4px;margin-top:61px"> 相同部份： </div> -->
           
            <!-- <div style="width:300px;margin-left:20px"> 
                <div style="font-size:12px;display:flex">
                    <div style="width:120px" >对比BOM产品2 </div>     
                    <el-input size="medium" v-model="v_matno3" @focus="inputBtn('MATNO3')" placeholder="请选择" style="width:100%;border:1px solid #389"></el-input>
                </div>
                <div style="font-size:12px;display:flex;margin-top:5px">
                    <div style="width:120px" > 产品名称</div>    
                    <el-input  size="medium" v-model="v_matnm3" disabled  style="width:100%"></el-input> 
                </div>
                <div style="font-size:12px;display:flex;margin-top:5px">
                    <div style="width:120px" > 规格描述</div>    
                    <el-input size="medium" type="textarea" rows="2" resize="none" v-model="v_specnm3" disabled  style="width:100%"></el-input> 
                </div>
            </div> -->
            
        </div> 
        <div style=" display:flex; background:#ccc;color:#DC143C;line-height:25px;height:25px;width:1320px;margin-top:2px ">
            
            <div style="font-size:12px;text-align:center;width:80px;border-right:1px dashed #389">物料编码</div>
            <div style="font-size:12px;text-align:center;width:120px;border-right:1px dashed #389">物料名称</div>
            <div style="font-size:12px;text-align:center;width:210px;border-right:1px dashed #389">规格型号</div>
            <div style="font-size:12px;padding-left:3px;width:40px;border-right:1px dashed #389">单位 </div>
            <div style="font-size:12px;text-align:center;width:65px;border-right:1px dashed #389">bom数量</div>
            <div style="font-size:12px;text-align:center;width:65px;border-right:1px dashed #389">单价</div>
            <div style="font-size:12px;text-align:center;width:80px;border-right:1px dashed #389">物料成本</div>
            <div style="font-size:12px;text-align:center;width:65px;border-right:1px dashed #389;margin-left:390px  ">bom数量</div>
            <div style="font-size:12px;text-align:center;width:65px;border-right:1px dashed #389">单价</div>
            <div style="font-size:12px;text-align:center;width:80px;border-right:1px dashed #389">物料成本</div>

        </div>
        <!-- 资料明细 -->
        <div style="overflow:auto;height:330px; width:1320px; " >
            <div v-for="(item,index) in tabData" :key="index" :class="item.AMT==item.AMT2 ?'divok':'divnot'">  
                <div style="font-size:11px; width:80px;border-right:1px dashed #CCC;padding-left:5px">{{item['MATNO']}}</div>
                <div :title="item['MATNM']" style="font-size:11px;padding-left:2px; width:120px;border-right:1px dashed #CCC;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;">{{item['MATNM']}}</div>
                <div :title="item['SPECNM']" style="font-size:11px;padding-left:2px; width:210px;border-right:1px dashed #CCC;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;">{{item['SPECNM']}}</div>
                <div style="font-size:12px;padding-left:3px;width:40px;padding-left:2px;border-right:1px dashed #CCC">{{item['UNITNM']}}</div>
                <div style="font-size:11px;text-align:right;width:65px;border-right:1px dashed #CCC;padding-right:5px">{{item['QTY']}}</div>
                <div style="font-size:11px;text-align:right;width:65px;border-right:1px dashed #CCC;padding-right:5px">{{item['POPRC']}}</div>
                <div style="font-size:11px;text-align:right;width:80px;border-right:1px dashed #CCC;padding-right:5px">{{item['AMT']}}</div>
                
                <div style="font-size:11px;text-align:right;width:65px;border-right:1px dashed #CCC;padding-right:5px;margin-left:390px">{{item['QTY2']}}</div>
                <div style="font-size:11px;text-align:right;width:65px;border-right:1px dashed #CCC;padding-right:5px">{{item['POPRC2']}}</div>
                <div style="font-size:11px;text-align:right;width:80px;border-right:1px dashed #CCC;padding-right:5px">{{item['AMT2']}}</div>
            </div>    

        </div>
        <div  style=" display:flex; background:#ccc; line-height:30px;height:30px;color:#DC143C  ">  
            <div style="font-size:13px; width:80px;border-right:1px dashed #389;font-weight:600;padding-left:5px">小计：</div>
            <div style="font-size:11px; width:80px;border-right:1px dashed #389;font-weight:600;text-align:right;margin-left:500px;padding-right:3px">{{v_amt1}}</div>
            <div style="font-size:11px; width:80px;border-right:1px dashed #389;font-weight:600;text-align:right;margin-left:520px;padding-right:3px">{{v_amt2}}</div>
        </div>
        <!-- 不同部份 -->
        <div style="  width:1379px; display:flex" >
            <div>
                <div style=" display:flex; background:#ccc;color:#404695;line-height:25px;height:25px;width:660px;margin-top:2px ">       
                    <div style="font-size:12px;text-align:center;width:80px;border-right:1px dashed #389">物料编码</div>
                    <div style="font-size:12px;text-align:center;width:120px;border-right:1px dashed #389">物料名称</div>
                    <div style="font-size:12px;text-align:center;width:210px;border-right:1px dashed #389">规格型号</div>
                    <div style="font-size:12px;padding-left:3px;width:40px;border-right:1px dashed #389">单位 </div>
                    <div style="font-size:12px;text-align:center;width:65px;border-right:1px dashed #389">bom数量</div>
                    <div style="font-size:12px;text-align:center;width:65px;border-right:1px dashed #389">单价</div>
                    <div style="font-size:12px;text-align:center;width:80px;border-right:1px dashed #389">物料成本</div>
                </div>
                <div :style="{'overflow':'auto','height':tabHeight,'width':'660px' } " >
                    <div v-for="(item,index) in noData" :key="index" style=" display:flex; background:#fff; line-height:25px;height:25px;  ">  
                        <div style="font-size:11px; width:80px;border-right:1px dashed #CCC;padding-left:5px">{{item['MATNO']}}</div>
                        <div :title="item['MATNM']" style="font-size:11px;padding-left:2px; width:120px;border-right:1px dashed #CCC;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;">{{item['MATNM']}}</div>
                        <div :title="item['SPECNM']" style="font-size:11px;padding-left:2px; width:210px;border-right:1px dashed #CCC;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;">{{item['SPECNM']}}</div>
                        <div style="font-size:12px;padding-left:3px;width:40px;padding-left:2px;border-right:1px dashed #CCC">{{item['UNITNM']}}</div>
                        <div style="font-size:11px;text-align:right;width:65px;border-right:1px dashed #CCC;padding-right:5px">{{item['QTY']}}</div>
                        <div style="font-size:11px;text-align:right;width:65px;border-right:1px dashed #CCC;padding-right:5px">{{item['POPRC']}}</div>
                        <div style="font-size:11px;text-align:right;width:80px;border-right:1px dashed #CCC;padding-right:5px">{{item['AMT']}}</div>
                    </div> 
                </div>
                <div  style=" display:flex; background:#ccc; line-height:30px;height:30px;color:#DC143C ;width:660px ">  
                    <div style="font-size:13px; width:180px;border-right:1px dashed #389;font-weight:600;padding-left:5px">合计物料成本：{{v_ttlamt1}}</div>
                    <div style="font-size:11px; width:80px;border-right:1px dashed #389;font-weight:600;text-align:right;margin-left:392px;padding-right:3px">{{v_noamt1}}</div>
                </div>
            </div>
            <!-- 第二个产品 -->
            <div style="margin-left:2px">
                <div style=" display:flex; background:#ccc;color:#404695;line-height:25px;height:25px;width:660px;margin-top:2px ">       
                    <div style="font-size:12px;text-align:center;width:80px;border-right:1px dashed #389">物料编码</div>
                    <div style="font-size:12px;text-align:center;width:120px;border-right:1px dashed #389">物料名称</div>
                    <div style="font-size:12px;text-align:center;width:210px;border-right:1px dashed #389">规格型号</div>
                    <div style="font-size:12px;padding-left:3px;width:40px;border-right:1px dashed #389">单位 </div>
                    <div style="font-size:12px;text-align:center;width:65px;border-right:1px dashed #389">bom数量</div>
                    <div style="font-size:12px;text-align:center;width:65px;border-right:1px dashed #389">单价</div>
                    <div style="font-size:12px;text-align:center;width:80px;border-right:1px dashed #389">物料成本</div>
                </div>
                <div :style="{'overflow':'auto','height':tabHeight,'width':'660px' } " >
                    <div v-for="(item,index) in noData2" :key="index" style=" display:flex; background:#fff; line-height:25px;height:25px;  ">  
                        <div style="font-size:11px; width:80px;border-right:1px dashed #CCC;padding-left:5px">{{item['MATNO']}}</div>
                        <div :title="item['MATNM']" style="font-size:11px;padding-left:2px; width:120px;border-right:1px dashed #CCC;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;">{{item['MATNM']}}</div>
                        <div :title="item['SPECNM']" style="font-size:11px;padding-left:2px; width:210px;border-right:1px dashed #CCC;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;">{{item['SPECNM']}}</div>
                        <div style="font-size:12px;padding-left:3px;width:40px;padding-left:2px;border-right:1px dashed #CCC">{{item['UNITNM']}}</div>
                        <div style="font-size:11px;text-align:right;width:65px;border-right:1px dashed #CCC;padding-right:5px">{{item['QTY']}}</div>
                        <div style="font-size:11px;text-align:right;width:65px;border-right:1px dashed #CCC;padding-right:5px">{{item['POPRC']}}</div>
                        <div style="font-size:11px;text-align:right;width:80px;border-right:1px dashed #CCC;padding-right:5px">{{item['AMT']}}</div>
                    </div> 
                </div>
                <div  style=" display:flex; background:#ccc; line-height:30px;height:30px;color:#DC143C ;width:660px ">  
                    <div style="font-size:13px; width:180px;border-right:1px dashed #389;font-weight:600;padding-left:5px">合计物料成本：{{v_ttlamt2}}</div>
                    <div style="font-size:11px; width:80px;border-right:1px dashed #389;font-weight:600;text-align:right;margin-left:392px;padding-right:3px">{{v_noamt2}}</div>
                </div>
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
 
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
 
    </div>
</template>
<script>
import pubWin from '../datamgt/pubwin.vue'  
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate} from '../../api/Select' 
//局部注册
export default {
    name:"bom_compare",
    data () {
        return {
 
            v_loading:false,

            saveFlag:false,
            promptWin:false,
            prompt:'',
            stfgCss:'',
            perWin:false,
            stfgColor:'',
            noData:[],
            noData2:[],
            loadWin:false,
  
 
            disabled:false, //新增权限制
 
            ruleValidate:{},
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            tabData:[], //表数据
            tabArr:[], //表列 
            operArr:[],           
            comboArr:{},
            oper:'like',
            txtparam:'',
            selparam:'',
            oper2:'like',
            txtparam2:'',
            selparam2:'',
            delArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_noamt1:0,
            v_noamt2:0,
            v_amt1:0,
            notNull:[],
            v_amt2:0,
 
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            v_matno1:'',
            v_matnm1:'',
            v_specnm1:'',
            v_matno2:'',
            v_matnm2:'',
            v_specnm2:'',
            v_matno3:'',
            v_matnm3:'',
            v_specnm3:'',
            v_key:'',

            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            btnWin:false,
        }
    },
    mounted () { 
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
 
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','424291','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
 
    },
    computed: {
        selWidth: function() {
            return (window.innerWidth - 220) + 'px';
        },
        tabHeight: function() {
            return (window.innerHeight - 640) + 'px';
        }, 
        v_ttlamt1: function() {
            return (Number(this.v_amt1) +Number(this.v_noamt1)).toFixed(4)
        }, 
        v_ttlamt2: function() {
            return (Number(this.v_amt2) +Number(this.v_noamt2)).toFixed(4)
        },
    },
    components: {
        pubWin,
    },
    created () {       
        if (this.v_username){ 
            //查询数据
           
            this.getTabField() //表列字段
   
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        btnSure(obj){
            if (this.v_key =='MATNO'){
                this.v_matno1 =obj['MATNO']
                this.v_matnm1 =obj['MATNM']
                this.v_specnm1 =obj['SPECNM']
            }else if (this.v_key =='MATNO2'){
                this.v_matno2 =obj['MATNO']
                this.v_matnm2 =obj['MATNM']
                this.v_specnm2 =obj['SPECNM']
            }if (this.v_key =='MATNO3'){
                this.v_matno3 =obj['MATNO']
                this.v_matnm3 =obj['MATNM']
                this.v_specnm3 =obj['SPECNM']
            }        
            this.btnWin =false
        },
        inputBtn( key){
            this.v_key =key    
             
            this.v_table ='v_prd_bom'
            this.tableCol =this.tabArr
            this.v_key2 =''
            this.v_value2 =''
            this.btnWin =true
             
        },
 
        //bom明细
        getBomList(){
            if (!this.v_matno1){
                this.promptWin =true
                this.prompt ='树状BOM产品 不能为空'
            }else{
                this.loadWin =true
                let v_cond='' ,v_cond2='' ,v_cond3=''
                if (this.v_matno2 ){
                    v_cond =' and matno in (select matno from V_TREE_NET where prdno=\''+this.v_matno2+'\' and corpid='+this.v_corpid+')'
                    v_cond2 =' and matno not in (select matno from V_TREE_NET where prdno=\''+this.v_matno2+'\' and corpid='+this.v_corpid+')'
                    v_cond3 =' and matno not in (select matno from V_TREE_NET where prdno=\''+this.v_matno1+'\' and corpid='+this.v_corpid+')'
                }else{
                    v_cond2=' and 1=2'
                    v_cond3=' and 1=2'
                }
                this.v_amt1 =0
                this.v_amt2 =0
                this.tabData=[]
                this.v_noamt1 =0
                this.v_noamt2=0
                this.noData =[]
                this.noData2 =[]
                //1、两个产品的 相同部份       
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'PRDNO', p_value:this.v_matno1,p_key2:'corpid', p_value2:this.v_corpid,p_cond:v_cond+ ' order by matno',p_table:'V_TREE_NET'},
                }).then(res=>{ 
                    if (res.code==='200'){
                        this.tabData =res.result
                        if (this.v_matno2){
                            let v_data =[]
                            //对比产品数据
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/getBaseData',
                                data: {p_key:'PRDNO', p_value:this.v_matno2,p_key2:'corpid', p_value2:this.v_corpid ,p_table:'V_TREE_NET'},
                            }).then(res=>{ 
                                v_data =res.result
                                this.tabData.forEach(item =>{
                                    v_data.some(it =>{
                                        if (it['MATNO']==item['MATNO']){
                                            item['QTY2'] =it['QTY']
                                            item['POPRC2'] =it['POPRC']
                                            item['AMT2'] =it['AMT']
                                            this.v_amt2 =(Number(this.v_amt2)+Number(it['AMT'])).toFixed(4)
                                        }
                                    })
                                    this.v_amt1 =(Number(this.v_amt1)+Number(item['AMT'])).toFixed(4)
                                })
                                
                            })
                        }else{
                            this.tabData.forEach(item =>{
                                this.v_amt1 =(Number(this.v_amt1)+Number(item['AMT'])).toFixed(4)
                            })
                            //this.loadWin=false
                        }
                        // 2. 不同部份
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/getBaseData',
                            data: {p_key:'PRDNO', p_value:this.v_matno1,p_key2:'corpid', p_value2:this.v_corpid,p_cond:v_cond2+ ' order by matnm',p_table:'V_TREE_NET'},
                        }).then(res=>{ 
                            this.noData =res.result
                            this.noData.forEach(item =>{
                                this.v_noamt1 =(Number(this.v_noamt1)+Number(item['AMT'])).toFixed(4)
                            })
                            //产品2 不同部份
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/getBaseData',
                                data: {p_key:'PRDNO', p_value:this.v_matno2,p_key2:'corpid', p_value2:this.v_corpid,p_cond:v_cond3+ ' order by matnm',p_table:'V_TREE_NET'},
                            }).then(res=>{ 
                                this.noData2 =res.result
                                this.noData2.forEach(item =>{
                                    this.v_noamt2 =(Number(this.v_noamt2)+Number(item['AMT'])).toFixed(4)
                                })
                                this.loadWin=false
                            })
                        })
                    }else{
                        this.loadWin=false
                        this.promptWin=true
                        this.prompt=res.result
                    }
                }) 
                
            }
        },
        //导出BOM对比表格：按当前UI重新生成HTML表格，Excel/WPS打开后可保留主要样式
        exportBomCompareExcel(){
            if (!this.tabData.length && !this.noData.length && !this.noData2.length){
                if (this.$message){
                    this.$message.warning('没有可导出的BOM对比数据')
                }else{
                    this.promptWin =true
                    this.prompt ='没有可导出的BOM对比数据'
                }
                return
            }
            let html =this.buildBomCompareExcelHtml()
            let blob =new Blob(['\ufeff' + html], {type:'application/vnd.ms-excel;charset=utf-8;'})
            let link =document.createElement('a')
            let fileName ='BOM对比_'+(this.v_matno1 || '产品1')+(this.v_matno2 ? '_VS_'+this.v_matno2 : '')+'_'+getDate('full')+'.xls'
            link.href =URL.createObjectURL(blob)
            link.download =fileName
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(link.href)
        },
        buildBomCompareExcelHtml(){
            let sameRows =this.tabData.map(item =>{
                let diff =Number(item['AMT']) !== Number(item['AMT2'])
                return '<tr class="'+(diff ? 'row-diff' : '')+'">'
                    + this.td(item['MATNO'], 'left')
                    + this.td(item['MATNM'], 'left')
                    + this.td(item['SPECNM'], 'left')
                    + this.td(item['UNITNM'], 'left')
                    + this.td(item['QTY'], 'right')
                    + this.td(item['POPRC'], 'right')
                    + this.td(item['AMT'], 'right')
                    + this.td('', 'center', 'separator')
                    + '<td colspan="4" class="separator"></td>'
                    + this.td(item['QTY2'], 'right')
                    + this.td(item['POPRC2'], 'right')
                    + this.td(item['AMT2'], 'right')
                    + '</tr>'
            }).join('')
            let noRows =this.buildDifferentRows()
            return '<html><head><meta charset="UTF-8"><style>'
                + 'table{border-collapse:collapse;font-family:Arial,"Microsoft YaHei",sans-serif;font-size:11px;table-layout:fixed;}'
                + 'td,th{height:25px;padding:0 4px;white-space:nowrap;}'
                + '.title{background:#fff;font-size:12px;height:30px;}'
                + '.label{color:#DC143C;font-weight:bold;}'
                + '.header-red th{background:#ccc;color:#DC143C;text-align:center;font-size:12px;font-weight:bold;}'
                + '.header-blue th{background:#ccc;color:#404695;text-align:center;font-size:12px;font-weight:bold;}'
                + '.total td{background:#ccc;color:#DC143C;font-weight:bold;height:30px;}'
                + '.row-diff td{background:rgb(233,229,229);color:red;}'
                + '.separator{background:#fff;}'
                + '.left{text-align:left;}.right{text-align:right;}.center{text-align:center;}'
                + '</style></head><body>'
                + '<table border="1" cellspacing="0" cellpadding="0">'
                + '<colgroup>'
                + '<col style="width:80px"><col style="width:120px"><col style="width:210px"><col style="width:40px"><col style="width:65px"><col style="width:65px"><col style="width:80px"><col style="width:20px"><col style="width:80px"><col style="width:120px"><col style="width:210px"><col style="width:40px"><col style="width:65px"><col style="width:65px"><col style="width:80px">'
                + '</colgroup>'
                + '<tr class="title"><td class="label">树状BOM产品</td><td colspan="2">'+this.escapeExcelHtml(this.v_matno1)+'</td><td colspan="4">'+this.escapeExcelHtml(this.v_matnm1)+'</td><td class="separator"></td><td class="label">对比BOM产品</td><td colspan="2">'+this.escapeExcelHtml(this.v_matno2)+'</td><td colspan="4">'+this.escapeExcelHtml(this.v_matnm2)+'</td></tr>'
                + '<tr class="title"><td>规格描述</td><td colspan="6">'+this.escapeExcelHtml(this.v_specnm1)+'</td><td class="separator"></td><td>规格描述</td><td colspan="6">'+this.escapeExcelHtml(this.v_specnm2)+'</td></tr>'
                + '<tr><td colspan="15"></td></tr>'
                + '<tr class="header-red"><th>物料编码</th><th>物料名称</th><th>规格型号</th><th>单位</th><th>bom数量</th><th>单价</th><th>物料成本</th><th colspan="5" class="separator"></th><th>bom数量</th><th>单价</th><th>物料成本</th></tr>'
                + sameRows
                + '<tr class="total"><td>小计：</td><td colspan="5"></td><td class="right">'+this.escapeExcelHtml(this.v_amt1)+'</td><td class="separator"></td><td colspan="6"></td><td class="right">'+this.escapeExcelHtml(this.v_amt2)+'</td></tr>'
                + '<tr><td colspan="15"></td></tr>'
                + '<tr class="header-blue"><th>物料编码</th><th>物料名称</th><th>规格型号</th><th>单位</th><th>bom数量</th><th>单价</th><th>物料成本</th><th class="separator"></th><th>物料编码</th><th>物料名称</th><th>规格型号</th><th>单位</th><th>bom数量</th><th>单价</th><th>物料成本</th></tr>'
                + noRows
                + '<tr class="total"><td colspan="3">合计物料成本：'+this.escapeExcelHtml(this.v_ttlamt1)+'</td><td colspan="3"></td><td class="right">'+this.escapeExcelHtml(this.v_noamt1)+'</td><td class="separator"></td><td colspan="3">合计物料成本：'+this.escapeExcelHtml(this.v_ttlamt2)+'</td><td colspan="3"></td><td class="right">'+this.escapeExcelHtml(this.v_noamt2)+'</td></tr>'
                + '</table></body></html>'
        },
        buildDifferentRows(){
            let len =Math.max(this.noData.length, this.noData2.length)
            let rows =[]
            for (let i=0; i<len; i++){
                let left =this.noData[i] || {}
                let right =this.noData2[i] || {}
                rows.push('<tr>'
                    + this.td(left['MATNO'], 'left')
                    + this.td(left['MATNM'], 'left')
                    + this.td(left['SPECNM'], 'left')
                    + this.td(left['UNITNM'], 'left')
                    + this.td(left['QTY'], 'right')
                    + this.td(left['POPRC'], 'right')
                    + this.td(left['AMT'], 'right')
                    + this.td('', 'center', 'separator')
                    + this.td(right['MATNO'], 'left')
                    + this.td(right['MATNM'], 'left')
                    + this.td(right['SPECNM'], 'left')
                    + this.td(right['UNITNM'], 'left')
                    + this.td(right['QTY'], 'right')
                    + this.td(right['POPRC'], 'right')
                    + this.td(right['AMT'], 'right')
                    + '</tr>')
            }
            return rows.join('')
        },
        td(value, align, extClass){
            return '<td class="'+(align || 'left')+(extClass ? ' '+extClass : '')+'">'+this.escapeExcelHtml(value)+'</td>'
        },
        escapeExcelHtml(value){
            if (value === undefined || value === null){
                return ''
            }
            return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
        },

        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','424291','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        notnull:res.result[k].NOTNULL,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .divok{
        display:flex; 
        background:#fff; 
        line-height:25px;
        height:25px;
    }
    .divnot{
        display:flex; 
        background:rgb(233, 229, 229); 
        color:red;
        line-height:25px;
        height:25px;
    }
 
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .el-table__body {
        width: 100%;
        // 使表格兼容safari，不错位
        table-layout: fixed !important;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 